import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0px;
`

export const SubContainer = styled(Container)`
  padding: 0px;
  margin-bottom: 20px;
`

export const TabRow = styled(Container)`
  flex-direction: row;
  padding: 0px;
  gap: 10px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: 140px repeat(3, 1fr) 20px;
  justify-content: center;
  align-items: flex-end;
  justify-items: center;
  margin: 15px 0px 7px;
  padding: 0px 15px;
  width: 840px;

  p {
    &:first-child {
      justify-self: flex-start;
      margin-left: 25px;
    }
  }
`

export const TabButton = styled.button`
  color: ${props => props.selected ? '#FFFFFF' : props.color};
  background-color: ${props => props.selected ? props.color : '#FFFFFF'};
  font-size: 14px;
  font-weight: bold;
  width: 200px;
  height: 38px;
  margin: 0px 0px 10px;
  border: 0px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #FFFFFF;
    background-color: ${props => props.color};
  }
`

export const Header = styled.div`
  padding: 12px 20px;
  background-color: #FFFFFF;
  flex-direction: row;
  justify-content: center;
`

export const InfoContainer = styled(Link)`
  width: 840px;
  height: 40px;
  display: grid;
  grid-template-columns: 140px repeat(3, 1fr) 20px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 8px 15px !important;
  margin-bottom: 10px;
  text-decoration: none;

  &:hover { background-color: #F7F7F7; }

  p {
    &:first-child {
      justify-self: flex-start;
    }
  }
`

export const BusinessContainer = styled.div`
  width: 840px;
  height: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 8px 15px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover { background-color: #F7F7F7; }

  p {
    &:first-child {
      justify-self: flex-start;
    }
  }
`

export const Info = styled(InfoContainer)`
  margin: 10px 0px 0px;
  padding: 0px !important;
  border: 0px;
  box-shadow: none;
  align-items: center;
  width: 100%;
`

export const FilterContainer = styled.div`
  width: 480px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 10px;
  height: auto;
  gap: 10px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`

export const LinkButton = styled(Link)`
  color: #FFC100;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
`
